export default "__VITE_ASSET__DwaUL8$r__"